import { Howl } from "howler";

export interface AudioService {
    loadAudio(onChange: (pct: number) => void): Promise<void>;
    playCardFlip(): void;
    playValidHand(): void;
}

const SOUNDS = [
    ["start", "shuffle"],
    ["flip", "card"],
    ["score", "score"],
]

const sounds: Record<string, Howl> = {}

export class WebAudioService implements AudioService {
    loadAudio(onChange: (pct: number) => void): Promise<void> {
        return new Promise((resolve, reject) => {
            for (const s of SOUNDS) {
                sounds[s[0]] = new Howl({ src: [`audio/${s[1]}.ogg`, `audio/${s[1]}.mp3`], preload: true })
                    .once("load", onLoaded)
                    .once("loaderror", onErrored)
                    .load();
            }

            let count = 0;
            function onLoaded() {
                if (++count === SOUNDS.length) {
                    resolve();
                }
                onChange(count / SOUNDS.length);
            }
            function onErrored(id: number, error: unknown): void {
                reject(error);
            }
        });
    }

    playGameStart(): void {
        sounds.start.play();
    }

    playCardFlip(): void {
        sounds.flip.play();
    }

    playValidHand(): void {
        sounds.score.play();
    }
}